var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.CUSTOMER !== "ROGERS"
    ? _c(
        "v-dialog",
        {
          key: _vm.storeSettingVisible,
          attrs: { width: "850", scrollable: "", persistent: "" },
          scopedSlots: _vm._u(
            [
              {
                key: "activator",
                fn: function(ref) {
                  var on = ref.on
                  var attrs = ref.attrs
                  return [
                    _c(
                      "v-btn",
                      _vm._g(
                        _vm._b(
                          {
                            attrs: { disabled: _vm.buttonDisabled, text: "" },
                            on: {
                              click: function($event) {
                                return _vm.showStoreSettingData()
                              }
                            }
                          },
                          "v-btn",
                          attrs,
                          false
                        ),
                        on
                      ),
                      [
                        _c("img", {
                          attrs: {
                            src: require("@/assets/img/ico-setting.png"),
                            alt: ""
                          }
                        })
                      ]
                    )
                  ]
                }
              }
            ],
            null,
            false,
            2666013312
          ),
          model: {
            value: _vm.storeSettingVisible,
            callback: function($$v) {
              _vm.storeSettingVisible = $$v
            },
            expression: "storeSettingVisible"
          }
        },
        [
          _c(
            "v-card",
            { staticClass: "popup" },
            [
              _c(
                "v-card-title",
                [
                  _c("h3", [
                    _c("i", { staticClass: "ico ico-store mb-4" }),
                    _vm._v(_vm._s(_vm.$t("Store Setting")) + " ")
                  ]),
                  _vm.visionCompEnable
                    ? _c(
                        "v-tabs",
                        {
                          staticClass: "custom-tabs",
                          attrs: {
                            "background-color": "#001e38",
                            color: "#fff",
                            grow: ""
                          },
                          model: {
                            value: _vm.activeTab,
                            callback: function($$v) {
                              _vm.activeTab = $$v
                            },
                            expression: "activeTab"
                          }
                        },
                        [
                          _c("v-tab", [
                            _vm._v(_vm._s(_vm.$t("Store Settings")))
                          ]),
                          _c(
                            "v-tab",
                            {
                              nativeOn: {
                                click: function($event) {
                                  $event.preventDefault()
                                  return _vm.handleVisionTabClick($event)
                                }
                              }
                            },
                            [_vm._v(_vm._s(_vm.$t("Vision Configuration")))]
                          )
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              ),
              _c(
                "v-card-text",
                { ref: "tabContent" },
                [
                  _c(
                    "v-tabs-items",
                    {
                      class: !_vm.visionCompEnable ? "mt-2" : "",
                      model: {
                        value: _vm.activeTab,
                        callback: function($$v) {
                          _vm.activeTab = $$v
                        },
                        expression: "activeTab"
                      }
                    },
                    [
                      _c(
                        "v-tab-item",
                        [
                          _vm._l(_vm.storeInputs, function(inputs, idx) {
                            return _c(
                              "v-row",
                              { key: idx },
                              _vm._l(inputs, function(input, colIdx) {
                                return _c(
                                  "v-col",
                                  {
                                    key: input.key,
                                    staticClass: "pt-2",
                                    attrs: { cols: "4" }
                                  },
                                  [
                                    input.selectable
                                      ? _c("v-select", {
                                          ref: input.key,
                                          refInFor: true,
                                          class: _vm.getStoreInputSelectClass(
                                            input.name
                                          ),
                                          attrs: {
                                            disabled: input.disabled,
                                            items: input.options,
                                            label: _vm.$t(input.label) + "*",
                                            placeholder: input.value
                                              ? ""
                                              : _vm.getPlaceholder(input),
                                            outlined: "",
                                            dense: "",
                                            "hide-details": "",
                                            attach: ""
                                          },
                                          on: {
                                            change: function($event) {
                                              _vm.setSelectableAreaNames(idx)
                                              _vm.setConditionsforChLbs(input)
                                            },
                                            keydown: _vm.clearTabindex
                                          },
                                          model: {
                                            value: input.value,
                                            callback: function($$v) {
                                              _vm.$set(input, "value", $$v)
                                            },
                                            expression: "input.value"
                                          }
                                        })
                                      : !input.selectable &&
                                        input.key === "storeDescription"
                                      ? _c("v-text-field", {
                                          class: _vm.getStoreInputTextClass(
                                            input.key,
                                            input.key === "countryInput" ||
                                              input.key === "regionInput" ||
                                              input.key === "cityInput"
                                              ? 1
                                              : idx
                                          ),
                                          attrs: {
                                            disabled:
                                              input.disabled ||
                                              _vm.areaAddDisabled,
                                            label: "" + _vm.$t(input.label),
                                            placeholder: _vm.getPlaceholder(
                                              input
                                            ),
                                            outlined: "",
                                            dense: "",
                                            "hide-details": "",
                                            clearable: ""
                                          },
                                          on: {
                                            keypress: _vm.handleKeyUpspl,
                                            keydown: _vm.clearTabindex
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              _vm.isAreaInput(input.key)
                                                ? {
                                                    key: "append",
                                                    fn: function() {
                                                      return [
                                                        _c(
                                                          "v-btn",
                                                          {
                                                            attrs: {
                                                              disabled:
                                                                _vm.areaAddDisabled,
                                                              text: ""
                                                            },
                                                            on: {
                                                              click: function(
                                                                $event
                                                              ) {
                                                                return _vm.addAreaValue(
                                                                  input.value,
                                                                  idx,
                                                                  colIdx - 1,
                                                                  input.key
                                                                )
                                                              }
                                                            }
                                                          },
                                                          [
                                                            _c("img", {
                                                              attrs: {
                                                                src: require("@/assets/img/btn-save.jpg"),
                                                                alt: ""
                                                              }
                                                            })
                                                          ]
                                                        )
                                                      ]
                                                    },
                                                    proxy: true
                                                  }
                                                : null
                                            ],
                                            null,
                                            true
                                          ),
                                          model: {
                                            value: input.value,
                                            callback: function($$v) {
                                              _vm.$set(input, "value", $$v)
                                            },
                                            expression: "input.value"
                                          }
                                        })
                                      : _c("v-text-field", {
                                          ref: input.key,
                                          refInFor: true,
                                          class: _vm.getStoreInputTextClass(
                                            input.key,
                                            idx
                                          ),
                                          attrs: {
                                            disabled:
                                              input.disabled ||
                                              _vm.areaAddDisabled,
                                            label: _vm.$t(input.label) + "*",
                                            placeholder: _vm.getPlaceholder(
                                              input
                                            ),
                                            outlined: "",
                                            dense: "",
                                            "hide-details": "",
                                            clearable: ""
                                          },
                                          on: {
                                            keypress: _vm.handleKeyUpspl,
                                            keydown: _vm.clearTabindex
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              _vm.isAreaInput(input.key)
                                                ? {
                                                    key: "append",
                                                    fn: function() {
                                                      return [
                                                        _c(
                                                          "v-btn",
                                                          {
                                                            attrs: {
                                                              disabled:
                                                                _vm.areaAddDisabled,
                                                              text: ""
                                                            },
                                                            on: {
                                                              click: function(
                                                                $event
                                                              ) {
                                                                return _vm.addAreaValue(
                                                                  input.value,
                                                                  idx,
                                                                  colIdx - 1,
                                                                  input.key
                                                                )
                                                              }
                                                            }
                                                          },
                                                          [
                                                            _c("img", {
                                                              attrs: {
                                                                src: require("@/assets/img/btn-save.jpg"),
                                                                alt: ""
                                                              }
                                                            })
                                                          ]
                                                        )
                                                      ]
                                                    },
                                                    proxy: true
                                                  }
                                                : null
                                            ],
                                            null,
                                            true
                                          ),
                                          model: {
                                            value: input.value,
                                            callback: function($$v) {
                                              _vm.$set(input, "value", $$v)
                                            },
                                            expression: "input.value"
                                          }
                                        })
                                  ],
                                  1
                                )
                              }),
                              1
                            )
                          }),
                          _c(
                            "v-expansion-panels",
                            {
                              staticClass: "advancedSetting",
                              attrs: { flat: "", accordion: "" },
                              model: {
                                value: _vm.advancedSettingVisible,
                                callback: function($$v) {
                                  _vm.advancedSettingVisible = $$v
                                },
                                expression: "advancedSettingVisible"
                              }
                            },
                            [
                              _c(
                                "v-expansion-panel",
                                [
                                  _c(
                                    "v-expansion-panel-header",
                                    { staticClass: "pl-0 pr-0" },
                                    [
                                      _c("i", { staticClass: "throwline" }),
                                      _vm._v(
                                        _vm._s(_vm.$t("Show Advanced Setting"))
                                      )
                                    ]
                                  ),
                                  _c(
                                    "v-expansion-panel-content",
                                    [
                                      _vm._l(_vm.advStoreInputs, function(
                                        advInputs,
                                        idx
                                      ) {
                                        return _c(
                                          "v-row",
                                          { key: idx },
                                          _vm._l(advInputs, function(advInput) {
                                            return _c(
                                              "v-col",
                                              {
                                                key: advInput.name,
                                                staticClass: "pt-1 pb-1",
                                                attrs: { cols: "4" }
                                              },
                                              [
                                                advInput.selectable
                                                  ? _c("v-select", {
                                                      class: _vm.getStoreInputSelectClass(
                                                        advInput.name
                                                      ),
                                                      attrs: {
                                                        label: _vm.$t(
                                                          advInput.label
                                                        ),
                                                        placeholder: _vm.getPlaceholder(
                                                          advInput
                                                        ),
                                                        items: advInput.options,
                                                        outlined: "",
                                                        dense: "",
                                                        "hide-details": ""
                                                      },
                                                      on: {
                                                        keydown:
                                                          _vm.clearTabindex
                                                      },
                                                      model: {
                                                        value: advInput.value,
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            advInput,
                                                            "value",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "advInput.value"
                                                      }
                                                    })
                                                  : _c("v-text-field", {
                                                      class: _vm.getStoreInputSelectClass(
                                                        advInput.name
                                                      ),
                                                      attrs: {
                                                        min: advInput.min
                                                          ? advInput.min
                                                          : -100000,
                                                        max: advInput.max
                                                          ? advInput.max
                                                          : 100000,
                                                        disabled:
                                                          advInput.disabled,
                                                        label: _vm.$t(
                                                          advInput.label
                                                        ),
                                                        placeholder: _vm.getPlaceholder(
                                                          advInput
                                                        ),
                                                        outlined: "",
                                                        dense: "",
                                                        error: advInput.error,
                                                        "error-messages":
                                                          advInput.errorMessage,
                                                        "hide-details": "auto",
                                                        type: "number"
                                                      },
                                                      on: {
                                                        keyup: function(
                                                          $event
                                                        ) {
                                                          $event.preventDefault()
                                                          return _vm.handleKeyUp(
                                                            $event
                                                          )
                                                        },
                                                        blur:
                                                          _vm.validateAdvInputOnBlur
                                                      },
                                                      model: {
                                                        value: advInput.value,
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            advInput,
                                                            "value",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "advInput.value"
                                                      }
                                                    })
                                              ],
                                              1
                                            )
                                          }),
                                          1
                                        )
                                      }),
                                      _vm.notifications
                                        ? _c(
                                            "v-row",
                                            [
                                              _c(
                                                "v-col",
                                                { attrs: { cols: "12" } },
                                                [
                                                  _c(
                                                    "h3",
                                                    {
                                                      staticClass: "mt-5",
                                                      staticStyle: {
                                                        "padding-left": "0px",
                                                        color: "#0A2640",
                                                        "line-height": "1",
                                                        "font-weight": "bold"
                                                      }
                                                    },
                                                    [
                                                      _c("u", [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$t(
                                                              "SERVER SENT EVENT SETTINGS"
                                                            )
                                                          )
                                                        )
                                                      ])
                                                    ]
                                                  ),
                                                  _c(
                                                    "div",
                                                    { staticClass: "row" },
                                                    [
                                                      _c("v-col", [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass: "ml-1",
                                                            staticStyle: {
                                                              "margin-top":
                                                                "24px"
                                                            }
                                                          },
                                                          [
                                                            _vm.notifications
                                                              ? _c(
                                                                  "span",
                                                                  [
                                                                    _c(
                                                                      "v-label",
                                                                      [
                                                                        _vm._v(
                                                                          " " +
                                                                            _vm._s(
                                                                              _vm.$t(
                                                                                "Picking"
                                                                              )
                                                                            ) +
                                                                            " : "
                                                                        )
                                                                      ]
                                                                    ),
                                                                    _c(
                                                                      "v-switch",
                                                                      {
                                                                        staticClass:
                                                                          "form-switch",
                                                                        staticStyle: {
                                                                          "margin-left":
                                                                            "10px",
                                                                          "vertical-align":
                                                                            "sub",
                                                                          display:
                                                                            "inline-block"
                                                                        },
                                                                        attrs: {
                                                                          inset:
                                                                            "",
                                                                          "hide-details":
                                                                            "",
                                                                          solo:
                                                                            ""
                                                                        },
                                                                        model: {
                                                                          value:
                                                                            _vm.picking,
                                                                          callback: function(
                                                                            $$v
                                                                          ) {
                                                                            _vm.picking = $$v
                                                                          },
                                                                          expression:
                                                                            "picking"
                                                                        }
                                                                      }
                                                                    )
                                                                  ],
                                                                  1
                                                                )
                                                              : _vm._e(),
                                                            _vm.notifications
                                                              ? _c(
                                                                  "span",
                                                                  {
                                                                    staticClass:
                                                                      "ml-2"
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "v-label",
                                                                      [
                                                                        _vm._v(
                                                                          " " +
                                                                            _vm._s(
                                                                              _vm.$t(
                                                                                "Alarm"
                                                                              )
                                                                            ) +
                                                                            " : "
                                                                        )
                                                                      ]
                                                                    ),
                                                                    _c(
                                                                      "v-switch",
                                                                      {
                                                                        staticClass:
                                                                          "form-switch",
                                                                        staticStyle: {
                                                                          "margin-left":
                                                                            "10px",
                                                                          "vertical-align":
                                                                            "sub",
                                                                          display:
                                                                            "inline-block"
                                                                        },
                                                                        attrs: {
                                                                          inset:
                                                                            "",
                                                                          "hide-details":
                                                                            "",
                                                                          solo:
                                                                            ""
                                                                        },
                                                                        model: {
                                                                          value:
                                                                            _vm.alarm,
                                                                          callback: function(
                                                                            $$v
                                                                          ) {
                                                                            _vm.alarm = $$v
                                                                          },
                                                                          expression:
                                                                            "alarm"
                                                                        }
                                                                      }
                                                                    )
                                                                  ],
                                                                  1
                                                                )
                                                              : _vm._e(),
                                                            _vm.notifications
                                                              ? _c(
                                                                  "span",
                                                                  {
                                                                    staticClass:
                                                                      "ml-2"
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "v-label",
                                                                      [
                                                                        _vm._v(
                                                                          " " +
                                                                            _vm._s(
                                                                              _vm.$t(
                                                                                "BlinkLED"
                                                                              )
                                                                            ) +
                                                                            " : "
                                                                        )
                                                                      ]
                                                                    ),
                                                                    _c(
                                                                      "v-switch",
                                                                      {
                                                                        staticClass:
                                                                          "form-switch",
                                                                        staticStyle: {
                                                                          "margin-left":
                                                                            "10px",
                                                                          "vertical-align":
                                                                            "sub",
                                                                          display:
                                                                            "inline-block"
                                                                        },
                                                                        attrs: {
                                                                          inset:
                                                                            "",
                                                                          "hide-details":
                                                                            "",
                                                                          solo:
                                                                            ""
                                                                        },
                                                                        model: {
                                                                          value:
                                                                            _vm.blinkled,
                                                                          callback: function(
                                                                            $$v
                                                                          ) {
                                                                            _vm.blinkled = $$v
                                                                          },
                                                                          expression:
                                                                            "blinkled"
                                                                        }
                                                                      }
                                                                    )
                                                                  ],
                                                                  1
                                                                )
                                                              : _vm._e(),
                                                            _vm.notifications
                                                              ? _c(
                                                                  "span",
                                                                  {},
                                                                  [
                                                                    _c(
                                                                      "v-label",
                                                                      [
                                                                        _vm._v(
                                                                          " " +
                                                                            _vm._s(
                                                                              _vm.$t(
                                                                                "Success Status"
                                                                              )
                                                                            ) +
                                                                            " : "
                                                                        )
                                                                      ]
                                                                    ),
                                                                    _c(
                                                                      "v-switch",
                                                                      {
                                                                        staticClass:
                                                                          "form-switch",
                                                                        staticStyle: {
                                                                          "margin-left":
                                                                            "10px",
                                                                          "vertical-align":
                                                                            "sub",
                                                                          display:
                                                                            "inline-block"
                                                                        },
                                                                        attrs: {
                                                                          inset:
                                                                            "",
                                                                          "hide-details":
                                                                            "",
                                                                          solo:
                                                                            ""
                                                                        },
                                                                        model: {
                                                                          value:
                                                                            _vm.successStatus,
                                                                          callback: function(
                                                                            $$v
                                                                          ) {
                                                                            _vm.successStatus = $$v
                                                                          },
                                                                          expression:
                                                                            "successStatus"
                                                                        }
                                                                      }
                                                                    )
                                                                  ],
                                                                  1
                                                                )
                                                              : _vm._e()
                                                          ]
                                                        )
                                                      ])
                                                    ],
                                                    1
                                                  )
                                                ]
                                              )
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                      _vm.notifications
                                        ? _c(
                                            "v-row",
                                            [
                                              _c(
                                                "v-col",
                                                { attrs: { cols: "12" } },
                                                [
                                                  _c(
                                                    "div",
                                                    { staticClass: "row" },
                                                    [
                                                      _c(
                                                        "v-col",
                                                        {
                                                          attrs: { cols: "7" }
                                                        },
                                                        [
                                                          _c("v-text-field", {
                                                            staticClass:
                                                              "form-input",
                                                            attrs: {
                                                              label: _vm.$t(
                                                                "SSE Event URL for Subscription Details"
                                                              ),
                                                              placeholder:
                                                                "URL",
                                                              outlined: "",
                                                              dense: "",
                                                              "hide-details":
                                                                "",
                                                              disabled: ""
                                                            },
                                                            model: {
                                                              value: _vm.sseUrl,
                                                              callback: function(
                                                                $$v
                                                              ) {
                                                                _vm.sseUrl = $$v
                                                              },
                                                              expression:
                                                                "sseUrl"
                                                            }
                                                          })
                                                        ],
                                                        1
                                                      )
                                                    ],
                                                    1
                                                  )
                                                ]
                                              )
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                      _vm.keycloakEnabled === true &&
                                      _vm.notifications
                                        ? _c(
                                            "span",
                                            {
                                              staticStyle: {
                                                color: "#cb7272",
                                                display: "flex"
                                              }
                                            },
                                            [
                                              _c(
                                                "p",
                                                {
                                                  staticStyle: {
                                                    "font-weight": "bold",
                                                    "margin-right": "5px"
                                                  }
                                                },
                                                [_vm._v("*Note : ")]
                                              ),
                                              _vm._v(
                                                "Since the AIMS Security module is enabled, a valid API key or access token must be provided for subscription."
                                              )
                                            ]
                                          )
                                        : _vm._e()
                                    ],
                                    2
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        2
                      ),
                      _c(
                        "v-tab-item",
                        [
                          _c("vision-config-modal", {
                            model: {
                              value: _vm.visionConfig,
                              callback: function($$v) {
                                _vm.visionConfig = $$v
                              },
                              expression: "visionConfig"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "v-card-actions",
                { staticClass: "d-flex justify-center" },
                [
                  _c(
                    "v-btn",
                    {
                      staticClass: "btn",
                      attrs: { text: "", icon: "" },
                      on: { click: _vm.handleSaveBtnClick }
                    },
                    [_vm._v(_vm._s(_vm.$t("Save")))]
                  ),
                  _c(
                    "v-btn",
                    {
                      staticClass: "btn",
                      attrs: { text: "", icon: "" },
                      on: {
                        click: function($event) {
                          return _vm.cancelStoreSetting()
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("Cancel")))]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    : _c(
        "v-dialog",
        {
          attrs: { width: "850", scrollable: "", persistent: "" },
          scopedSlots: _vm._u([
            {
              key: "activator",
              fn: function(ref) {
                var on = ref.on
                var attrs = ref.attrs
                return [
                  _c(
                    "v-btn",
                    _vm._g(
                      _vm._b(
                        {
                          attrs: { disabled: _vm.buttonDisabled, text: "" },
                          on: {
                            click: function($event) {
                              return _vm.showStoreSettingData()
                            }
                          }
                        },
                        "v-btn",
                        attrs,
                        false
                      ),
                      on
                    ),
                    [
                      _c("img", {
                        attrs: {
                          src: require("@/assets/img/ico-setting.png"),
                          alt: ""
                        }
                      })
                    ]
                  )
                ]
              }
            }
          ]),
          model: {
            value: _vm.storeSettingVisible,
            callback: function($$v) {
              _vm.storeSettingVisible = $$v
            },
            expression: "storeSettingVisible"
          }
        },
        [
          _c(
            "v-card",
            { staticClass: "popup" },
            [
              _c("v-card-title", [
                _c("h3", [
                  _c("i", { staticClass: "ico ico-store" }),
                  _vm._v(_vm._s(_vm.$t("Store Setting")))
                ])
              ]),
              _c(
                "v-card-text",
                [
                  _vm._l(_vm.newStoreInputs, function(inputs, idx) {
                    return _c(
                      "v-row",
                      { key: idx },
                      _vm._l(inputs, function(input, colIdx) {
                        return _c(
                          "v-col",
                          {
                            key: input.key,
                            staticClass: "pt-2",
                            attrs: { cols: "4" }
                          },
                          [
                            input.selectable
                              ? _c("v-select", {
                                  ref: input.key,
                                  refInFor: true,
                                  class: _vm.getStoreInputSelectClass(
                                    input.name
                                  ),
                                  attrs: {
                                    disabled: input.disabled,
                                    items: input.options,
                                    label: _vm.$t(input.label) + "*",
                                    placeholder: input.value
                                      ? ""
                                      : _vm.getPlaceholder(input),
                                    outlined: "",
                                    dense: "",
                                    "hide-details": "",
                                    attach: ""
                                  },
                                  on: {
                                    change: function($event) {
                                      _vm.setSelectableAreaNames(idx)
                                      _vm.setConditionsforChLbs(input)
                                    },
                                    keydown: _vm.clearTabindex
                                  },
                                  model: {
                                    value: input.value,
                                    callback: function($$v) {
                                      _vm.$set(input, "value", $$v)
                                    },
                                    expression: "input.value"
                                  }
                                })
                              : !input.selectable &&
                                input.key === "storeDescription"
                              ? _c("v-text-field", {
                                  ref: input.key,
                                  refInFor: true,
                                  class: _vm.getStoreInputTextClass(
                                    input.key,
                                    idx
                                  ),
                                  attrs: {
                                    disabled:
                                      input.disabled || _vm.areaAddDisabled,
                                    label: "" + _vm.$t(input.label),
                                    placeholder: _vm.getPlaceholder(input),
                                    outlined: "",
                                    dense: "",
                                    "hide-details": "",
                                    clearable: ""
                                  },
                                  on: {
                                    keypress: _vm.handleKeyUpspl,
                                    keydown: _vm.clearTabindex
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      _vm.isAreaInput(input.key)
                                        ? {
                                            key: "append",
                                            fn: function() {
                                              return [
                                                _c(
                                                  "v-btn",
                                                  {
                                                    attrs: {
                                                      disabled:
                                                        _vm.areaAddDisabled,
                                                      text: ""
                                                    },
                                                    on: {
                                                      click: function($event) {
                                                        return _vm.addAreaValue(
                                                          input.value,
                                                          idx,
                                                          colIdx - 1,
                                                          input.key
                                                        )
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _c("img", {
                                                      attrs: {
                                                        src: require("@/assets/img/btn-save.jpg"),
                                                        alt: ""
                                                      }
                                                    })
                                                  ]
                                                )
                                              ]
                                            },
                                            proxy: true
                                          }
                                        : null
                                    ],
                                    null,
                                    true
                                  ),
                                  model: {
                                    value: input.value,
                                    callback: function($$v) {
                                      _vm.$set(input, "value", $$v)
                                    },
                                    expression: "input.value"
                                  }
                                })
                              : _c("v-text-field", {
                                  ref: input.key,
                                  refInFor: true,
                                  class: _vm.getStoreInputTextClass(
                                    input.key,
                                    idx
                                  ),
                                  attrs: {
                                    disabled:
                                      input.disabled || _vm.areaAddDisabled,
                                    label: _vm.$t(input.label) + "*",
                                    placeholder: _vm.getPlaceholder(input),
                                    outlined: "",
                                    dense: "",
                                    "hide-details": "",
                                    clearable: ""
                                  },
                                  on: {
                                    keypress: _vm.handleKeyUpspl,
                                    keydown: _vm.clearTabindex
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      _vm.isAreaInput(input.key)
                                        ? {
                                            key: "append",
                                            fn: function() {
                                              return [
                                                _c(
                                                  "v-btn",
                                                  {
                                                    attrs: {
                                                      disabled:
                                                        _vm.areaAddDisabled,
                                                      text: ""
                                                    },
                                                    on: {
                                                      click: function($event) {
                                                        return _vm.addAreaValue(
                                                          input.value,
                                                          idx,
                                                          colIdx - 1,
                                                          input.key
                                                        )
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _c("img", {
                                                      attrs: {
                                                        src: require("@/assets/img/btn-save.jpg"),
                                                        alt: ""
                                                      }
                                                    })
                                                  ]
                                                )
                                              ]
                                            },
                                            proxy: true
                                          }
                                        : null
                                    ],
                                    null,
                                    true
                                  ),
                                  model: {
                                    value: input.value,
                                    callback: function($$v) {
                                      _vm.$set(input, "value", $$v)
                                    },
                                    expression: "input.value"
                                  }
                                })
                          ],
                          1
                        )
                      }),
                      1
                    )
                  }),
                  _c(
                    "v-expansion-panels",
                    {
                      staticClass: "advancedSetting",
                      attrs: { flat: "", accordion: "" },
                      model: {
                        value: _vm.advancedSettingVisible,
                        callback: function($$v) {
                          _vm.advancedSettingVisible = $$v
                        },
                        expression: "advancedSettingVisible"
                      }
                    },
                    [
                      _c(
                        "v-expansion-panel",
                        [
                          _c(
                            "v-expansion-panel-header",
                            { staticClass: "pl-0 pr-0" },
                            [
                              _c("i", { staticClass: "throwline" }),
                              _vm._v(_vm._s(_vm.$t("Show Advanced Setting")))
                            ]
                          ),
                          _c(
                            "v-expansion-panel-content",
                            [
                              _vm._l(_vm.advStoreInputs, function(
                                advInputs,
                                idx
                              ) {
                                return _c(
                                  "v-row",
                                  { key: idx },
                                  _vm._l(advInputs, function(advInput) {
                                    return _c(
                                      "v-col",
                                      {
                                        key: advInput.name,
                                        staticClass: "pt-1 pb-1",
                                        attrs: { cols: "4" }
                                      },
                                      [
                                        advInput.selectable
                                          ? _c("v-select", {
                                              class: _vm.getStoreInputSelectClass(
                                                advInput.name
                                              ),
                                              attrs: {
                                                label: _vm.$t(advInput.label),
                                                placeholder: _vm.getPlaceholder(
                                                  advInput
                                                ),
                                                items: advInput.options,
                                                outlined: "",
                                                dense: "",
                                                "hide-details": ""
                                              },
                                              on: {
                                                keydown: _vm.clearTabindex
                                              },
                                              model: {
                                                value: advInput.value,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    advInput,
                                                    "value",
                                                    $$v
                                                  )
                                                },
                                                expression: "advInput.value"
                                              }
                                            })
                                          : _c("v-text-field", {
                                              class: _vm.getStoreInputSelectClass(
                                                advInput.name
                                              ),
                                              attrs: {
                                                min: advInput.min
                                                  ? advInput.min
                                                  : -100000,
                                                max: advInput.max
                                                  ? advInput.max
                                                  : 100000,
                                                disabled: advInput.disabled,
                                                label: _vm.$t(advInput.label),
                                                placeholder: _vm.getPlaceholder(
                                                  advInput
                                                ),
                                                outlined: "",
                                                dense: "",
                                                "hide-details": "",
                                                type: "number"
                                              },
                                              on: {
                                                keyup: function($event) {
                                                  $event.preventDefault()
                                                  return _vm.handleKeyUp($event)
                                                }
                                              },
                                              model: {
                                                value: advInput.value,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    advInput,
                                                    "value",
                                                    $$v
                                                  )
                                                },
                                                expression: "advInput.value"
                                              }
                                            })
                                      ],
                                      1
                                    )
                                  }),
                                  1
                                )
                              }),
                              _vm.notifications
                                ? _c(
                                    "v-row",
                                    [
                                      _c("v-col", { attrs: { cols: "12" } }, [
                                        _c(
                                          "h3",
                                          {
                                            staticClass: "mt-5",
                                            staticStyle: {
                                              "padding-left": "0px",
                                              color: "#0A2640",
                                              "line-height": "1",
                                              "font-weight": "bold"
                                            }
                                          },
                                          [
                                            _c("u", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "SERVER SENT EVENT SETTINGS"
                                                  )
                                                )
                                              )
                                            ])
                                          ]
                                        ),
                                        _c(
                                          "div",
                                          { staticClass: "row" },
                                          [
                                            _c("v-col", [
                                              _c(
                                                "div",
                                                {
                                                  staticClass: "ml-1",
                                                  staticStyle: {
                                                    "margin-top": "24px"
                                                  }
                                                },
                                                [
                                                  _vm.notifications
                                                    ? _c(
                                                        "span",
                                                        [
                                                          _c("v-label", [
                                                            _vm._v(
                                                              " " +
                                                                _vm._s(
                                                                  _vm.$t(
                                                                    "Picking"
                                                                  )
                                                                ) +
                                                                " : "
                                                            )
                                                          ]),
                                                          _c("v-switch", {
                                                            staticClass:
                                                              "form-switch",
                                                            staticStyle: {
                                                              "margin-left":
                                                                "10px",
                                                              "vertical-align":
                                                                "sub",
                                                              display:
                                                                "inline-block"
                                                            },
                                                            attrs: {
                                                              inset: "",
                                                              "hide-details":
                                                                "",
                                                              solo: ""
                                                            },
                                                            model: {
                                                              value:
                                                                _vm.picking,
                                                              callback: function(
                                                                $$v
                                                              ) {
                                                                _vm.picking = $$v
                                                              },
                                                              expression:
                                                                "picking"
                                                            }
                                                          })
                                                        ],
                                                        1
                                                      )
                                                    : _vm._e(),
                                                  _vm.notifications
                                                    ? _c(
                                                        "span",
                                                        {},
                                                        [
                                                          _c("v-label", [
                                                            _vm._v(
                                                              " " +
                                                                _vm._s(
                                                                  _vm.$t(
                                                                    "Alarm"
                                                                  )
                                                                ) +
                                                                " : "
                                                            )
                                                          ]),
                                                          _c("v-switch", {
                                                            staticClass:
                                                              "form-switch",
                                                            staticStyle: {
                                                              "margin-left":
                                                                "10px",
                                                              "vertical-align":
                                                                "sub",
                                                              display:
                                                                "inline-block"
                                                            },
                                                            attrs: {
                                                              inset: "",
                                                              "hide-details":
                                                                "",
                                                              solo: ""
                                                            },
                                                            model: {
                                                              value: _vm.alarm,
                                                              callback: function(
                                                                $$v
                                                              ) {
                                                                _vm.alarm = $$v
                                                              },
                                                              expression:
                                                                "alarm"
                                                            }
                                                          })
                                                        ],
                                                        1
                                                      )
                                                    : _vm._e(),
                                                  _vm.notifications
                                                    ? _c(
                                                        "span",
                                                        {},
                                                        [
                                                          _c("v-label", [
                                                            _vm._v(
                                                              " " +
                                                                _vm._s(
                                                                  _vm.$t(
                                                                    "BlinkLED"
                                                                  )
                                                                ) +
                                                                " : "
                                                            )
                                                          ]),
                                                          _c("v-switch", {
                                                            staticClass:
                                                              "form-switch",
                                                            staticStyle: {
                                                              "margin-left":
                                                                "10px",
                                                              "vertical-align":
                                                                "sub",
                                                              display:
                                                                "inline-block"
                                                            },
                                                            attrs: {
                                                              inset: "",
                                                              "hide-details":
                                                                "",
                                                              solo: ""
                                                            },
                                                            model: {
                                                              value:
                                                                _vm.blinkled,
                                                              callback: function(
                                                                $$v
                                                              ) {
                                                                _vm.blinkled = $$v
                                                              },
                                                              expression:
                                                                "blinkled"
                                                            }
                                                          })
                                                        ],
                                                        1
                                                      )
                                                    : _vm._e(),
                                                  _vm.notifications
                                                    ? _c(
                                                        "span",
                                                        {},
                                                        [
                                                          _c("v-label", [
                                                            _vm._v(
                                                              " " +
                                                                _vm._s(
                                                                  _vm.$t(
                                                                    "Success Status"
                                                                  )
                                                                ) +
                                                                " : "
                                                            )
                                                          ]),
                                                          _c("v-switch", {
                                                            staticClass:
                                                              "form-switch",
                                                            staticStyle: {
                                                              "margin-left":
                                                                "10px",
                                                              "vertical-align":
                                                                "sub",
                                                              display:
                                                                "inline-block"
                                                            },
                                                            attrs: {
                                                              inset: "",
                                                              "hide-details":
                                                                "",
                                                              solo: ""
                                                            },
                                                            model: {
                                                              value:
                                                                _vm.successStatus,
                                                              callback: function(
                                                                $$v
                                                              ) {
                                                                _vm.successStatus = $$v
                                                              },
                                                              expression:
                                                                "successStatus"
                                                            }
                                                          })
                                                        ],
                                                        1
                                                      )
                                                    : _vm._e()
                                                ]
                                              )
                                            ]),
                                            _c(
                                              "v-col",
                                              {
                                                staticClass: "mt-2",
                                                attrs: { cols: "5" }
                                              },
                                              [
                                                _c("v-text-field", {
                                                  staticClass: "form-input",
                                                  attrs: {
                                                    label: _vm.$t(
                                                      "SSE Event URL for Subscription Details"
                                                    ),
                                                    placeholder: "URL",
                                                    outlined: "",
                                                    dense: "",
                                                    "hide-details": "",
                                                    disabled: ""
                                                  },
                                                  model: {
                                                    value: _vm.sseUrl,
                                                    callback: function($$v) {
                                                      _vm.sseUrl = $$v
                                                    },
                                                    expression: "sseUrl"
                                                  }
                                                })
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        )
                                      ])
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm.keycloakEnabled === true
                                ? _c(
                                    "span",
                                    {
                                      staticStyle: {
                                        color: "#cb7272",
                                        display: "flex"
                                      }
                                    },
                                    [
                                      _c(
                                        "p",
                                        {
                                          staticStyle: {
                                            "font-weight": "bold",
                                            "margin-right": "5px"
                                          }
                                        },
                                        [_vm._v("*Note : ")]
                                      ),
                                      _vm._v(
                                        "Since the AIMS Security module is enabled, a valid API key or access token must be provided for subscription."
                                      )
                                    ]
                                  )
                                : _vm._e()
                            ],
                            2
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                2
              ),
              _c(
                "v-card-actions",
                { staticClass: "d-flex justify-center" },
                [
                  _c(
                    "v-btn",
                    {
                      staticClass: "btn",
                      attrs: { text: "", icon: "" },
                      on: {
                        click: function($event) {
                          return _vm.handleSaveBtnClick()
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("Save")))]
                  ),
                  _c(
                    "v-btn",
                    {
                      staticClass: "btn",
                      attrs: { text: "", icon: "" },
                      on: {
                        click: function($event) {
                          return _vm.cancelStoreSetting()
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("Cancel")))]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }